import { QueryCache, MutationCache, QueryClient, Query, Mutation } from '@tanstack/react-query';
import { analytics } from '@app/app/analytics';
import { PlatformName } from '@app/app/analytics/types';

const handleQueryError = (
  error: Error,
  // TODO: We can store metadata about the query or mutation here to provide more context
  // eslint-disable-next-line @typescript-eslint/no-unused-vars,no-unused-vars
  action: Query<unknown, unknown, unknown> | Mutation<unknown, unknown, unknown>,
): void => {
  console.error('TanStack Query Error:', {
    message: error.message,
    timestamp: new Date().toISOString(),
    error,
  });

  analytics.emitEvent('service_error_system', {
    [PlatformName.GTM]: {
      // TODO: Add action URL
      action: 'TanStack Query Error',
      // TODO: Add http Code
      // httpCode: ,
      message: JSON.stringify(error),
    },
  });
};

const queryCache = new QueryCache({
  onError: (error, query) => handleQueryError(error, query),
});

const mutationCache = new MutationCache({
  onError: (error, _, __, mutation) => handleQueryError(error, mutation),
});

export const queryClient = new QueryClient({
  queryCache,
  mutationCache,
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000, // 5 minutes
    },
  },
});
